import clsx from "clsx";

export default function CircleBackground() {
  return (
    <div
      className={clsx(
        "fixed",
        "top-0",
        "left-0",
        "right-0",
        "bottom-0",
        "z-[-1]"
      )}
      style={{
        backgroundImage: "url(/backgrounds/circle-background.svg)",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    ></div>
  );
}
